<template>
   <BreadCrumb PageTitle="Ajouter un support de cours" />
    <AddSupport />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import AddSupport from "@/components/SupportDeCours/AddSupport.vue";
  
    export default defineComponent({
      name: "AddSupportPage",
      components: {
        BreadCrumb,
        AddSupport,
      },
    });
  </script>

